import { Moon, Sun } from 'lucide-react';
import { useEffect, useState } from 'react';
import { readAccountTheme } from '../lib/pageTheme';

type Theme = 'light' | 'dark';
const STORAGE_KEY = 'skrepka.theme';

function applyTheme(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#212121' : '#00a89c');
}

export function ThemeToggle({ menuItem = false }: { menuItem?: boolean }) {
  const [theme, setTheme] = useState<Theme>(readAccountTheme);
  useEffect(() => {
    const sync = (event: StorageEvent) => {
      if (event.key !== STORAGE_KEY && event.key !== null) return;
      const next = event.newValue === 'dark' ? 'dark' : 'light';
      applyTheme(next);
      setTheme(next);
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);

  const label = theme === 'light' ? 'Включить тёмный режим' : 'Включить светлый режим';
  return <button className={menuItem ? 'messenger-theme-setting' : 'theme-toggle'} role={menuItem ? 'menuitem' : undefined} type="button" aria-label={menuItem ? 'Сменить тему' : label} title={label} onClick={() => {
    const next = theme === 'light' ? 'dark' : 'light';
    applyTheme(next);
    setTheme(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* Theme still works for this tab. */ }
  }}>
    {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
    {menuItem && <span>Сменить тему</span>}
  </button>;
}

